export const locationVariety = {
  station: 1,
  dealer: 2,
  retail: 3,
};
